import { isUnderBookLaw } from "../../product/utils/isUnderBookLaw.js";
export function resolveFirstOrderPrice(product, selectedFirstBook) {
    if (!product.isSeries) {
        return 0;
    }
    if (product.campaignBooks.length > 0) {
        return product.initialPrice?.price || 0;
    }
    if (selectedFirstBook?.numberInSeries === 1 && product.initialPrice) {
        return product.initialPrice.price;
    }
    if (selectedFirstBook &&
        isUnderBookLaw(selectedFirstBook) &&
        selectedFirstBook.price) {
        return selectedFirstBook.price;
    }
    if (!product.recurringPrice) {
        throw new Error(`Missing recurring price for subscription sku: ${product.sku}`);
    }
    return product.recurringPrice.price;
}
